
// Example helper to group topics by date sections: Today, Yesterday, etc.
export function groupTopicsBySections(topicsList) {
    // Sort by lastModified descending
    const sorted = [...topicsList].sort((a, b) => (b.lastModified || 0) - (a.lastModified || 0));
  
    // Helper function
    const toDate = (unixSeconds) => new Date(unixSeconds * 1000);
  
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startOfYesterday = new Date(startOfToday);
    startOfYesterday.setDate(startOfYesterday.getDate() - 1);
  
    const sevenDaysAgo = new Date(now);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
  
    const thirtyDaysAgo = new Date(now);
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
  
    // Initialize sections in a stable order
    const sections = [
      { label: 'Today', topics: [] },
      { label: 'Yesterday', topics: [] },
      { label: 'Previous 7 days', topics: [] },
      { label: 'Previous 30 days', topics: [] },
    ];
  
    const monthNameToIndex = (monthName) => {
      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      return monthNames.indexOf(monthName);
    };
  
    // We'll store older topics by Month + Year
    const monthMap = {};
  
    sorted.forEach((topic) => {
      const lastModDate = toDate(topic.lastModified || 0);
  
      if (lastModDate >= startOfToday) {
        sections[0].topics.push(topic);
        return;
      }
      if (lastModDate >= startOfYesterday && lastModDate < startOfToday) {
        sections[1].topics.push(topic);
        return;
      }
      if (lastModDate >= sevenDaysAgo) {
        sections[2].topics.push(topic);
        return;
      }
      if (lastModDate >= thirtyDaysAgo) {
        sections[3].topics.push(topic);
        return;
      }
  
      // Older than 30 days => group by Month+Year (e.g., "January 2023")
      const year = lastModDate.getFullYear();
      const monthLabel = new Intl.DateTimeFormat('en', { month: 'long' }).format(lastModDate) + ` ${year}`;
  
      if (!monthMap[monthLabel]) {
        monthMap[monthLabel] = { label: monthLabel, topics: [] };
      }
      monthMap[monthLabel].topics.push(topic);
    });
  
    // Convert the monthMap to an array, sorted descending by date
    const monthSections = Object.values(monthMap).sort((a, b) => {
      const [monthA, yearA] = a.label.split(' ');
      const [monthB, yearB] = b.label.split(' ');
      const dateA = new Date(parseInt(yearA, 10), monthNameToIndex(monthA));
      const dateB = new Date(parseInt(yearB, 10), monthNameToIndex(monthB));
      return dateB - dateA; // most recent first
    });
  
    return [...sections, ...monthSections];
  }
  